import { render, staticRenderFns } from "./semiScreen.vue?vue&type=template&id=422e16ec&scoped=true"
import script from "./semiScreen.vue?vue&type=script&lang=js"
export * from "./semiScreen.vue?vue&type=script&lang=js"
import style0 from "./semiScreen.vue?vue&type=style&index=0&id=422e16ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422e16ec",
  null
  
)

export default component.exports